import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';

export const API_DOMAIN: EndPointsNames = 'ApiAuth0';
export const ENDPOINT_API_PATH = 'oauth/token';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';
const URL_POSTMAN = 'http://www.smiles.com.br';

export const CODE_ERRORS: ErrorResponseCodeType[] = [];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};
